<p-toast attachTo="body" />
<p-toast key="autoSaveToast">
	<ng-template let-message pTemplate="message">
		<div class="flex flex-column align-items-start" style="flex: 1">
			<div class="flex align-items-center gap-2">
				<span class="font-bold text-900">
					Sauvegarde automatique
				</span>
			</div>
			<div class="font-medium text-lg my-3 text-900">
				Sauvegarde automatique dans {{countdown | async}} secondes
			</div>
		</div>
	</ng-template>
</p-toast>
<p-menubar [model]="menuWithReturn()" [autoDisplay]="false" styleClass="detail-menu-bar">
    <!-- Edit Button -->
    <p-button 
        *ngIf="!modeModification && canEdit" 
        (click)="onEdit.emit()" 
        icon="pi pi-pencil"
        styleClass="p-button-primary modify-button"
        [pTooltip]="isMobile() ? 'Modifier' : ''"
        [label]="isMobile() ? '' : 'Modifier'"
        tooltipPosition="bottom">
    </p-button>
    
    <!-- Save Button -->
    <p-button 
        *ngIf="modeModification && canEdit" 
        (click)="handleSave()" 
        icon="pi pi-check"
        styleClass="p-button-success mr-2"
        [loading]="isSaving"
        pTooltip="Enregistrer (Ctrl+S)"
        tooltipPosition="bottom"
        [disabled]="isSaving">
    </p-button>
    
    <!-- Cancel Button -->
    <p-button 
        *ngIf="modeModification && canEdit" 
        (click)="confirmCancel()" 
        icon="pi pi-times"
        styleClass="p-button-secondary"
        pTooltip="Annuler (Échap)"
        tooltipPosition="bottom"
        [disabled]="isSaving">
    </p-button>
</p-menubar>

<!-- Confirmation Dialog for Cancel -->
<p-confirmDialog 
    header="Confirmation" 
    icon="pi pi-exclamation-triangle"
    acceptLabel="Oui, annuler"
    rejectLabel="Non, continuer">
</p-confirmDialog>

<!-- Unsaved Changes Indicator -->
<div *ngIf="hasUnsavedChanges && modeModification" 
     class="unsaved-indicator"
     pTooltip="Vous avez des modifications non sauvegardées"
     tooltipPosition="bottom">
    <i class="pi pi-exclamation-circle"></i>
</div>